export class UserData {
  constructor(
    public id: string,
    public username: string,
    public firstName: string,
    public lastName: string,
    public email: string,
    public phoneNumber: string,
    public customerId: string,
    public activityId: string
  ) {}
}
